<div class="card-body">
  <strong>Totalt antal scapister på site:</strong> {{info.all}}<br>
  <strong>Tillgängliga scapister:</strong> {{info.notInvitedScapists}}<br>
  <strong>Inbjudna scapister:</strong> {{info.invitedScapists}}<br>
  <strong>Lediga tider för startbesök:</strong> {{info.emptyStartVisitSlots}}<br>
  <div *ngIf="info.hasContinuedStartVisit"><strong>Lediga tider för forts. startbesök:</strong> {{info.emptyContinuedStartVisitSlots}}<br></div>
  <strong>Lediga tider för CT-besök:</strong> {{info.emptyCTVisitSlots}}<br>
</div>
